import { Avatar, Card, Col, Layout, Row, Image } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import CategorySidebar from "./sidebar";
import { useSelector } from "react-redux";
import { getImgUrl } from "../../../utils";
const { Content } = Layout;

const CategoryLayout = ({
  children,
  categoryId,
}: {
  children: ReactElement;
  categoryId: string;
}): ReactElement => {
  const { categoryInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
      <Layout className="min-vh-100">
        <section className="">
          <Row gutter={16}>
            <Col span={6}>
              <Card
                className="shop-sedebar card-padding-none h-100"
                cover={
                  <div className="show-details-inner-content">
                    <div className="shop-image-content">
                      <div className="shop-banner">
                        <Image
                          src={getImgUrl(categoryInfo?.bannerImage)}
                          alt={categoryInfo?.name}
                          className="rounded"
                        />
                      </div>

                      <div className="shop-image-content">
                        <div className="shop-logo">
                          <Avatar
                            size={105}
                            src={getImgUrl(categoryInfo?.image)}
                          />
                        </div>
                        <div className="body">
                          <h4>{categoryInfo?.title?.toUpperCase()}</h4>
                          <div className="mb-4">
                            <span className="radius-btn active-btn">
                              {categoryInfo?.type?.split("_").join(" ")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
                <CategorySidebar categoryId={categoryInfo?.id} />
              </Card>
            </Col>
            <Col span={18}>
              <Card
                className="product-information-show-tab-wrapper"
                size="small"
              >
                <Layout>
                  <Content className="main-content-layout">{children}</Content>
                </Layout>
              </Card>
            </Col>
          </Row>
        </section>
      </Layout>
    </React.Fragment>
  );
};

CategoryLayout.propType = {
  children: PropTypes.element,
};

export default CategoryLayout;
